<ag-grid-angular class="ag-theme-balham grid-table" [columnDefs]="columnDefs" [gridOptions]="gridOptions"
    (displayedColumnsChanged)="onDisplayedColumnsChanged()" (bodyScroll)="onBodyScroll($event)"
    (sortChanged)="onSortChanged($event)" (gridReady)="onGridReady($event)"></ag-grid-angular>